import React from "react";
import { Link } from "react-router-dom";

import brands from "../data/brands";

function BrandItem({ brand }) {
  const isAvailable = !!brand.href;
  const className =
    "font-accent text-[9px] sm:text-[10px] tracking-[0.15em] uppercase whitespace-nowrap transition-colors " +
    (isAvailable
      ? "text-maroon-700 font-semibold hover:text-gold-700"
      : "text-maroon-700/50 cursor-not-allowed");

  if (!isAvailable) {
    return (
      <span className={className} aria-disabled="true" title={`${brand.name} — coming soon`}>
        {brand.name}
        <span className="ml-1 normal-case tracking-normal text-[8px] sm:text-[9px]">(soon)</span>
      </span>
    );
  }

  if (brand.external) {
    return (
      <a href={brand.href} className={className} target="_blank" rel="noreferrer">
        {brand.name}
      </a>
    );
  }

  return (
    <Link to={brand.href} className={className}>
      {brand.name}
    </Link>
  );
}

export default function BrandSwitcher({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 sm:gap-3 ${className}`} aria-label="Switch brand">
      {brands.map((brand, i) => (
        <React.Fragment key={brand.id}>
          {i > 0 && (
            <span className="text-maroon-700/45 text-[9px]" aria-hidden="true">
              |
            </span>
          )}
          <BrandItem brand={brand} />
        </React.Fragment>
      ))}
    </div>
  );
}
